import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import Layout from "@components/layout/Layout";
import ExtractionPointRightLinkageWorkflow from "@components/form/extraction_point/extraction_right_linkage/ExtractionPointRightLinkageWorkflow";
import { useGetLevel1Resource } from "@hooks/query/useGetLevel1Resource";

const LinkExtractionPoint = () => {
  const { t } = useTranslation();
  const { id: level1ResourceId = "" } = useParams();
  const { data: level1Resource = {} } = useGetLevel1Resource(level1ResourceId, {
    enabled: Boolean(level1ResourceId),
  });

  return (
    <Layout
      permissions={["LinkExtractionPoint"]}
      breadcrumb={[
        {
          label: t("dashboard.dashboard"),
          href: "/polestar",
        },
        {
          label: level1Resource?.name,
          href: `/polestar/level1wrs/${level1ResourceId}`,
        },
        {
          label: t("level1wrs.extraction_points"),
          href: `/polestar/level1wrs/${level1ResourceId}#5`,
        },
        {
          label: t("extraction_point.linkage.title_link"),
        },
      ]}
      title={t("extraction_point.linkage.title_link")}
      accountingPeriodLevel1ResourceId={level1ResourceId}
    >
      <ExtractionPointRightLinkageWorkflow />
    </Layout>
  );
};

export default LinkExtractionPoint;
